import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import router from '@/router/index';
import useEventsBus from '@/utils/eventbus';

const authStoreName = 'credentials';

const { gEmit } = useEventsBus();

export const useAuthStore = defineStore('credentials', {
  state: () => ({
    authInfo: useStorage(authStoreName, {
      data: null
    }),
    userInfo: useStorage('userInfo', {
      data: null
    })
  }),
  actions: {
    saveAuthInfo(payload: any) {
      this.authInfo = {
        ...this.authInfo,
        ...payload
      };
    },
    saveUserInfo(payload: any) {
      this.userInfo = {
        ...this.userInfo,
        ...payload
      };
    },
    resetAuthData() {
      this.authInfo.data = null;
      this.userInfo.data = null;
    },
    gotoLogin() {
      // return router.push(Tr.i18nRoute({ name: 'authLogin' }))
      window.open('https://ion.ptpn.id/auth/login', '_self')?.focus();
    },
    raiseError(payload: any) {
      gEmit('showToast', {
        type: 'error',
        message: payload.message,
        Duration: 5,
        Position: 'top-center'
      });
    },
    gotoOffline() {
      router.push({ name: 'errorOffline' });
      return gEmit('gotoPage', 'errorOffline');
    }
  }
});
